import React, { useEffect, useState } from "react";
import AddCourtPopup from "../Component/AddCourtPopup";
import { API_BASE_URL } from "../config";

export default function Courts() {
  const [courts, setCourts] = useState([]);
  const [newCourt, setNewCourt] = useState({ courtName: "", location: "" });
  const [editingCourt, setEditingCourt] = useState(null);

  // Fetch all courts
  useEffect(() => {
    fetchCourts();
  }, []);

  const fetchCourts = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/CourtMaster/GetCourt`, {
          headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setCourts(data);
      } else {
        console.error("Failed to fetch courts");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Add new court
  const handleAddCourt = async (newCourt) => {
    // e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/CourtMaster/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newCourt),
      });
      if (res.ok) {
        fetchCourts(); // Refresh list
        setNewCourt({ courtName: "", location: "" });
        alert("Court added successfully!");
      } else {
        console.error("Failed to add court");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Delete court
  const handleDeleteCourt = async (id) => {
    if (!window.confirm("Are you sure you want to delete this court?")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/Court/deletecourt/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setCourts((prev) => prev.filter((c) => c.id !== id));
        alert("Court deleted successfully!");
      } else {
        console.error("Failed to delete court");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Update court
  const handleUpdateCourt = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/CourtMaster/update/${editingCourt.courtId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editingCourt),
      });
      if (res.ok) {
        fetchCourts();
        setEditingCourt(null);
        alert("Court updated successfully!");
      } else {
        console.error("Failed to update court");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Manage Courts</h2>
      
      <AddCourtPopup onAddCourt={handleAddCourt} />

      {/* Court Table */}
      <table border="1" cellPadding="10" style={{ width: "100%", marginTop: "20px" }}>
        <thead style={{ background: "#f4f4f4" }}>
          <tr>
            <th>Court Name</th>
            <th>Court Type</th>
            <th>City</th>
            <th>State</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {courts.length > 0 ? (
            courts.map((court) => (
              <tr key={court.courtId}>
                <td>
                  {editingCourt?.courtId === court.courtId ? (
                    <input
                      type="text"
                      value={editingCourt.courtName}
                      onChange={(e) =>
                        setEditingCourt({ ...editingCourt, courtName: e.target.value })
                      }
                    />
                  ) : (
                    court.courtName
                  )}
                </td>
                <td>
                  {editingCourt?.courtId === court.courtId ? (
                    <input
                      type="text"
                      value={editingCourt.courtType}
                      onChange={(e) =>
                        setEditingCourt({ ...editingCourt, courtType: e.target.value })
                      }
                    />
                  ) : (
                    court.courtType
                  )}
                </td>
                <td>
                  {editingCourt?.courtId === court.courtId ? (
                    <input
                      type="text"
                      value={editingCourt.state}
                      onChange={(e) =>
                        setEditingCourt({ ...editingCourt, state: e.target.value })
                      }
                    />
                  ) : (
                    court.state
                  )}
                </td>
                <td>
                  {editingCourt?.courtId === court.courtId ? (
                    <input
                      type="text"
                      value={editingCourt.location}
                      onChange={(e) =>
                        setEditingCourt({ ...editingCourt, location: e.target.value })
                      }
                    />
                  ) : (
                    court.location
                  )}
                </td>
                <td>
                  {editingCourt?.courtId === court.courtId ? (
                    <>
                      <button onClick={handleUpdateCourt}>Save</button>
                      <button onClick={() => setEditingCourt(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => setEditingCourt(court)}>Edit</button>
                      <button onClick={() => handleDeleteCourt(court.courtId)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No courts found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
